// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"a252ebeee69ec510d2ff","382":"621359d211b79567f98a","409":"972e04b3346d494811bc"}[chunkId] + ".chunk.js";
};